<template>
    <transition name="exit-intent-fade">
        <div v-if="showContent">
            <slot></slot>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'ExitIntent',
    data() {
        return {
            showContent: false,
            timeout: null
        };
    },
    props: {
        timeoutSeconds: {
            type: Number,
            default: 15
        },
        once: {
            type: Boolean,
            default: true
        }
    },
    computed: {},
    methods: {
        intentHandler(e) {
            if (!e.toElement && !e.relatedTarget) {
                this.showContent = true;
                this.once && this.removeListener();
            }
        },
        removeListener() {
            document.removeEventListener('mouseout', this.intentHandler);
        }
    },
    mounted() {
        this.removeListener();
        this.timeout = setTimeout(() => {
            document.addEventListener('mouseout', this.intentHandler);
        }, this.timeoutSeconds * 1000);
    },
    beforeDestroy() {
        clearTimeout(this.timeout);
        this.showContent = false;
        this.removeListener();
    }
};
</script>

<style scoped lang="scss"></style>
